import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { inject, runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import { CompoApp } from '../../services/CompoApp';
import { MessageDesignBUtils } from '../../content/components/message-design-b/message-design-b.utils';
import { calcDefaultTimeoutOf, RequestClientService } from '../../services/client/request-client.service';

export class SseModuleEvent extends SseEventBase {

  type: SseEventType = 'module';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.MODULE_RELEASE_BY_ME: {
          this.on.releasedModuleId$.next(resp.targetId);
          break;
        }
        case NotificationReasonEnum.MODULE_RELEASE_BY_ME_FAILED: {
          this.on.releasedModuleIdFailed$.next(resp.targetId);
          break;
        }
        case NotificationReasonEnum.MODULE_UPDATE_BY_ME: {
          inject(CompoApp).on.updatedModuleId$.next(resp.targetId);
          break;
        }
        case NotificationReasonEnum.ATTRIBUTE_IDENTIFIER_IN_GLOBAL_MODULE: {
          this.on.updatedModuleIdFailedAttribute$.next(resp.targetId);
          break;
        }
        case NotificationReasonEnum.MODULE_UPDATE_BY_ME_FAILED: {
          this.on.updatedModuleIdFailed$.next(resp.targetId);
          break;
        }
        case NotificationReasonEnum.MODULE_MERGED_BY_ME: {
          this.on.mergeModuleId$.next(resp.targetId);
          this.messageClientService.messages$.next(MessageDesignBUtils.createModuleMergeSuccess());
          break;
        }
        case NotificationReasonEnum.MODULE_MERGED_NEW_BY_ME: {
          this.on.mergeModuleNew$.next(resp.targetId);
          this.messageClientService.messages$.next(MessageDesignBUtils.createModuleMergeNewSuccess());
          break;
        }
        case NotificationReasonEnum.MODULE_MERGED_BY_ME_FAILED: {
          this.on.mergeModuleIdFailed$.next(resp.targetId);
          this.messageClientService.messages$.next(MessageDesignBUtils.createModuleMergeError());
          break;
        }
        case NotificationReasonEnum.MODULE_DELETED: {
          this.on.deleteModule$.next(null);
          break;
        }
        case NotificationReasonEnum.MODULE_DELETE_FAILED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.createModuleDeleteFailed());
          break;
        }
        case NotificationReasonEnum.UPGRADE_MODULE_RELEASE_JOB_ROUTINE_TEMPLATES_SUCCESS: {
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.messageClientService.messages$.next(
              MessageDesignBUtils.upgradeModuleReleaseJobRoutineTemplateSuccess()
            );
          }, 500);
          break;
        }
        case NotificationReasonEnum.UPGRADE_MODULE_RELEASE_JOB_ROUTINE_TEMPLATES_FAILED: {
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.messageClientService.messages$.next(
              MessageDesignBUtils.upgradeModuleReleaseJobRoutineTemplateFailed()
            );
          }, 500);
          break;
        }
        case NotificationReasonEnum.MODULE_CLASS_ALLOCATION_FAILED: {
          this.inProgressMessageService.removeMessage(resp.demandId);
          this.on.inProgressAsyncWorkFinished$.next(MessageDesignBUtils.saveModuleIdsForClassFailed());
          break;
        }
        case NotificationReasonEnum.MODULE_CLASS_ALLOCATION_SUCCESS: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.on.inProgressAsyncWorkFinished$.next(MessageDesignBUtils.saveModuleIdsForClassSuccess());
          }, calcDefaultTimeoutOf(new Date(start)));
          this.on.moduleClassAllocationFinished$.next(resp.bulkIds);
          break;
        }
        case NotificationReasonEnum.MODULE_CLASS_RELEASE_FAILED: {
          this.inProgressMessageService.removeMessage(resp.demandId);
          this.on.inProgressAsyncWorkFinished$.next(MessageDesignBUtils.releaseModuleIdsForClassFailed());
          break;
        }
        case NotificationReasonEnum.MODULE_CLASS_RELEASE_SUCCESS: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.on.inProgressAsyncWorkFinished$.next(MessageDesignBUtils.releaseModuleIdsForClassSuccess());
          }, calcDefaultTimeoutOf(new Date(start)));
          this.on.moduleClassAllocationFinished$.next(resp.bulkIds);
          break;
        }
      }
    });
  }
}
